// NPM
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';

import { Button } from 'react-bootstrap';

class HiddenTag extends PureComponent {
  handleClick = () => {
    const { hiddenTag: { id } } = this.props;
    this.props.deleteHiddenTag(id);
  };

  render() {
    const { tag } = this.props;
    if (!tag.name) return null;
    return (
      <div className={`HiddenTagContainer ${tag.displayClass}`}>
        <div className={`HiddenTag ${tag.displayClass}`}>
          <Button className="HiddenTag-btn" onClick={this.handleClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="HiddenTag-btn-icon"
              viewBox="0 0 13 13"
            >
              <path d="M12.712.298a.982.982 0 0 0-1.39 0L6.5 5.11 1.679.288a.982.982 0 1 0-1.39 1.39L5.108 6.5.29 11.321a.982.982 0 1 0 1.39 1.39L6.5 7.892l4.821 4.82a.982.982 0 1 0 1.39-1.39L7.892 6.5l4.82-4.821a.988.988 0 0 0 0-1.38z" />
            </svg>
          </Button>
          <span className="HiddenTag-name">{tag.name}</span>
        </div>
      </div>
    );
  }
}

HiddenTag.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    schema: PropTypes.string,
    displayClass: PropTypes.string,
  }).isRequired,
  hiddenTag: PropTypes.shape({
    objectContent: PropTypes.object,
  }),
};

function mapStateToProps(state, props) {
  return {
    tag: props.hiddenTag.object_content,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      deleteHiddenTag: actions.deleteHiddenTag,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(HiddenTag);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Tags/HiddenTag.js